import { useQuery } from '@tanstack/react-query';

import { addonEnvironment } from '@api/sdk.gen';

import { EnvironmentId } from '@/react/portainer/environments/types';

import { queryKeys } from './query-keys';

/**
 * useAddonEnvironmentId resolves the environment an add-on's Kubernetes
 * resources can be read through.
 *
 * data is undefined when none could be verified, which is a supported state:
 * the add-on still runs. A failed query is a third answer, unknown, which
 * callers must not treat as "none".
 */
export function useAddonEnvironmentId({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.environment(),
    queryFn: getAddonEnvironment,
    enabled,
    // 0 means "none verified".
    select: (data): EnvironmentId | undefined =>
      data.environmentId || undefined,
  });
}

async function getAddonEnvironment() {
  const { data } = await addonEnvironment();
  return data;
}
